import { forwardRef, type ComponentProps, type ReactNode } from "react"

import { cn } from "../lib/cn"

const LinhaDoTempo = forwardRef<HTMLOListElement, ComponentProps<"ol">>(function LinhaDoTempo({ className, ...props }, ref) {
  return <ol ref={ref} className={cn("m-0 flex list-none flex-col gap-4 p-3", className)} {...props} />
})

function GrupoDaLinhaDoTempo({ data, children }: { data: string; children: ReactNode }) {
  return (
    <li className="flex flex-col gap-2">
      <span
        data-slot="data-da-linha-do-tempo"
        className="mx-auto w-fit rounded-(--raio-pilula) border border-(--azul-200) bg-(--azul-100) px-3 py-0.5 text-(length:--texto-xs) font-semibold tracking-(--tracking-rotulo) text-(--sobre-azul-100) tabular-nums"
      >
        {data}
      </span>
      {children}
    </li>
  )
}

type PropsDoItem = Omit<ComponentProps<"button">, "children" | "title"> & {
  sobretitulo: ReactNode
  hora?: string | null
  titulo: ReactNode
  detalhe?: ReactNode
  marcas?: ReactNode
  ativo?: boolean
}

function ItemDaLinhaDoTempo({ sobretitulo, hora, titulo, detalhe, marcas, ativo = false, className, ...props }: PropsDoItem) {
  return (
    <button
      type="button"
      data-aberta={ativo ? "sim" : "nao"}
      aria-current={ativo ? "true" : undefined}
      className={cn(
        "flex w-full min-w-0 cursor-pointer flex-col gap-1 rounded-(--raio-2) border p-3 text-left transition-colors focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-(--foco)",
        ativo
          ? "border-(--acao) bg-(--azul-50) ring-1 ring-(--acao)/20"
          : "border-(--borda) bg-(--painel) hover:border-(--borda-forte)",
        className,
      )}
      {...props}
    >
      <span className="flex min-w-0 items-start gap-2">
        <span
          data-slot="sobretitulo-do-item"
          className="flex min-w-0 items-center gap-1 truncate text-(length:--texto-xs) font-bold tracking-(--tracking-rotulo) text-(--tinta-3) uppercase"
        >
          {sobretitulo}
        </span>
        {hora !== undefined && hora !== null && (
          <span data-slot="hora-do-item" className="ml-auto flex-none font-mono text-(length:--texto-xs) text-(--tinta-3)">
            {hora}
          </span>
        )}
      </span>
      <span className="text-(length:--texto-base) leading-snug font-bold text-(--tinta) wrap-anywhere">{titulo}</span>
      {detalhe !== undefined && detalhe !== null && (
        <span className="truncate text-(length:--texto-xs) text-(--tinta-2)">{detalhe}</span>
      )}
      {marcas !== undefined && marcas !== null && <span className="mt-1 flex flex-wrap items-center gap-1">{marcas}</span>}
    </button>
  )
}

export { LinhaDoTempo, GrupoDaLinhaDoTempo, ItemDaLinhaDoTempo }
